var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2774 1.63903H9.44706V0.185059H8.36022L0 1.64265V14.3611L8.31116 15.8151H9.44706V14.3665H14.903C15.212 14.352 15.5555 14.3756 15.8208 14.1866C16.0334 13.8613 15.9789 13.4542 15.9971 13.0871V2.34418C16.0352 1.92981 15.6918 1.59721 15.2774 1.63903ZM6.06297 10.47C5.75947 10.6281 5.30509 10.4627 4.94525 10.4881C4.70353 9.285 4.42181 8.08912 4.20556 6.88053C3.99291 8.05459 3.71666 9.21771 3.47312 10.3845C3.12419 10.3664 2.77344 10.3445 2.42266 10.3209C2.12094 8.72156 1.76656 7.13312 1.48484 5.53015C1.79562 5.51562 2.10822 5.5029 2.419 5.492C2.60619 6.64971 2.81884 7.80196 2.98244 8.9615C3.23869 7.77287 3.50038 6.58428 3.75484 5.39568C4.10016 5.37568 4.44547 5.36115 4.79078 5.34297C5.0325 6.56975 5.27966 7.79468 5.54138 9.016C5.74675 7.75471 5.97391 6.49703 6.19384 5.23756C6.55731 5.22484 6.92081 5.20484 7.28247 5.18303C6.87175 6.94412 6.51188 8.71978 6.06297 10.47ZM15.1321 13.5034H9.44706V12.3619H14.1724V11.6349H9.44706V10.7262H14.1724V9.99925H9.44706V9.0905H14.1724V8.36356H9.44706V7.45481H14.1724V6.72787H9.44706V5.81912H14.1724V5.09215H9.44706V4.18343H14.1724V3.45647H9.44706V2.49678H15.1321V13.5034Z",
    fill: "#2B6ED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.500998a2f7a60fe983d61b86e76218fe.svg";
export { ForwardRef as ReactComponent };